import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { CustomManufacturerCampaignAdapter } from "../custom-manufacturer-campaign.adapter";
import { CustomManufacturerCampaignOverview, ManufacturerCampaignSalesNotification, ManufacturerCampaignResultsData } from "../custom-manufacturer-campaign.models";
import * as CustomManufacturerCampaignActions from "./custom-manufacturer-campaign.actions";

@Injectable()
export class CustomManufacturerCampaignEffects {
  constructor(
    private actions$: Actions,
    private customManufacturerCampaignAdapter: CustomManufacturerCampaignAdapter
  ) {}

  getManufacturerCampaign$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomManufacturerCampaignActions.getManufacturerCampaign),
      switchMap((action) =>
      this.customManufacturerCampaignAdapter
        .getManufacturerCampaign(
          action.productCode,
          action.manufacturerNumber,
          action.manufacturerId,
          action.ean,
          action.campaignId,
          action.showOldData
        ).pipe(
          map(
            (
              manufacturercampaignOverview: CustomManufacturerCampaignOverview
            ) =>
              CustomManufacturerCampaignActions.getManufacturerCampaignSuccess(
                {
                  manufacturercampaignOverview,
                }
              )
          ),
          catchError((error) =>
            of(
              CustomManufacturerCampaignActions.getManufacturerCampaignFailure(
                {
                  error,
                }
              )
            )
          )
        )
      )
    );
  });

  getManufacturerCampaignDetails$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomManufacturerCampaignActions.getManufacturerCampaignDetails),
      switchMap((action) =>
        this.customManufacturerCampaignAdapter
          .getManufacturerCampaignDetails(
            action.campaignId,
            action.productCode
          )
          .pipe(
            map((manufacturerCampaignDetails: ManufacturerCampaignSalesNotification[]) =>
            CustomManufacturerCampaignActions.getManufacturerCampaignDetailsSuccess
              ({
                manufacturerCampaignDetails,
              })
            ),
            catchError((error) =>
              of(
                CustomManufacturerCampaignActions.getManufacturerCampaignDetailsFailure({
                  error,
                })
              )
            )
          )
      )
    );
  });

  deleteSalesNotification$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomManufacturerCampaignActions.deleteSalesNotification),
      switchMap((action) =>
        this.customManufacturerCampaignAdapter
          .deleteSalesNotification(
            action.salesNotificationPkList
          )
          .pipe(
            map((deleted: boolean) => {
              if (deleted && deleted === true) {
                return CustomManufacturerCampaignActions.deleteSalesNotificationSuccess();
              }
              else {
                return CustomManufacturerCampaignActions.deleteSalesNotificationFailure();
              }
            }),
            catchError(() =>
              of(
                CustomManufacturerCampaignActions.deleteSalesNotificationFailure()
              )
            )
          )
      )
    );
  });

  updateSalesNotification$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomManufacturerCampaignActions.updateSalesNotification),
      switchMap((action) =>
        this.customManufacturerCampaignAdapter
          .updateSalesNotification(
            action.salesNotifications
          )
          .pipe(
            map((message: ManufacturerCampaignResultsData[]) => {
              if (message && message.length > 0 && message[0].message == 'successfulEntries') {
                return CustomManufacturerCampaignActions.updateSalesNotificationSuccess();
              }
              else if(message){
                return CustomManufacturerCampaignActions.updateSalesNotificationFailure({errorMessage: message});
              }
            }),
            catchError(() =>
              of(
                CustomManufacturerCampaignActions.updateSalesNotificationFailure( {errorMessage: [ { message: "hasDuplicates"} ] as ManufacturerCampaignResultsData[] } )
              )
            )
          )
      )
    );
  });

}
